import { useOffsetBoxes } from '../../../scripts/utils/offsetBoxes';
import { initPromoBanner } from '../../../snippets/promo-banner/promo-banner';

export const initPromoBannerMenu = () => {
  initPromoBanner('promo-banner-menu', () =>
    useOffsetBoxes(`[data-offset-box="promo-banner-menu"]`)
  );

  useOffsetBoxes(`[data-offset-box="promo-banner-menu"]`);

  return true;
};
